import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import {
  AIDigestGif,
  greyColor,
  maxMobile,
  maxTablet,
  maxWidth,
  primaryFont, primaryHeadingColor, retina, secondaryFont,
  wMBold,
  wMedium,
} from 'Utils/utilsStyle';

const StyledModal = styled(Modal)`
  @media all and (max-width: ${maxWidth}), ${retina} {
    width: 527px !important;
  }
  @media all and (max-width: ${maxTablet}) {
    width: 440px !important;
  }
  @media all and (max-width: ${maxMobile}) {
    width: 359px !important;
  }
  .ant-modal-content {
    border-radius: 15px !important;
    .ant-modal-body {
      padding: 40px !important;
      height: 438px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        height: 353px;
      }
      @media all and (max-width: ${maxTablet}) {
        height: 293px;
      }
      @media all and (max-width: ${maxMobile}) {
        height: 263px;
      }
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .generating-digest {
        width: 240px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          width: 200px;
        }
        @media all and (max-width: ${maxTablet}) {
          width: 184px;
        }
        @media all and (max-width: ${maxMobile}) {
          width: 150px;
        }
      }
      .digest-text {
        color: #616161;
        text-align: center;
        font-family: ${secondaryFont};
        font-size: 24px;
        font-weight: ${wMBold};
        line-height: 26px;
        letter-spacing: -0.8px;
        margin-bottom: 37px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          font-size: 22px;
        }
        @media all and (max-width: ${maxTablet}) {
          font-size: 16px;
          line-height: 20px;
          margin-bottom: 23px;
        }
        @media all and (max-width: ${maxMobile}) {
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 19px;
        }
        &.title {
          color: ${primaryHeadingColor};
          font-size: 32px;
          line-height: 40px;
          margin-bottom: 16px;
          @media all and (max-width: ${maxWidth}), ${retina} {
            font-size: 28px;
          }
          @media all and (max-width: ${maxTablet}) {
            font-size: 24px;
            line-height: 30px;
            margin-bottom: 10px;
          }
          @media all and (max-width: ${maxMobile}) {
            margin-bottom: 7px;
          }
        }
      }     
      .paragraph-digest {
        color: ${greyColor};
        font-family: ${primaryFont};
        font-size: 16px;
        font-weight: ${wMedium};
        line-height: 22px;
        letter-spacing: -0.562px;
        width: 337px;
        text-align: center;
        @media all and (max-width: ${maxWidth}), ${retina} {
          width: 384px;
        }
        @media all and (max-width: ${maxTablet}) {
          font-size: 12px;
          line-height: 16px;
          width: 277px;
        }
        @media all and (max-width: ${maxMobile}) {
          font-size: 10px;
          line-height: 13px;
          width: 226px;
        }
      }
    }
  }
`;

type Props = {
  isIpPopup: boolean
};

const GenerateDigestPopup = function GenerateDigestPopup(props: Props) {
  const { isIpPopup } = props;
  return (
    <StyledModal
      centered
      open={isIpPopup}
      closable={false}
      width={580}
      footer={null}
    // maskStyle={{
    //   opacity: '0.3',
    //   backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // }}
    >
      <img src={AIDigestGif} className="generating-digest" alt="generating-digest" />
      <h4 className="digest-text">Reading...</h4>
      <h1 className="digest-text title">Generating your Digest...</h1>
      <p className="paragraph-digest">Please hold tight while I take a few minutes to generate the digest.</p>
    </StyledModal>
  );
};

export default GenerateDigestPopup;
